import { useState } from 'react'
import { ScoreExplainer } from 'components/memberScore'

/**
 * The (i) beside امتیاز on any member list.
 *
 * Both the dashboard card and the full list needed it, and both must open the
 * SAME explainer the grant wizard opens — a second "how the score works"
 * dialog is a second description of one formula, and they drift.
 *
 * The list rows carry `breakdown` for exactly this reason: the terms come
 * from the server that computed them, never re-derived here.
 */
export default function useScoreExplainer(data?: IAdminMembersList) {
    const [row, setRow] = useState<IAdminMemberRow | null>(null)

    const element = row ? (
        <ScoreExplainer
            show
            onHide={() => setRow(null)}
            candidate={row as unknown as ILoanCandidate}
            overdueMultiplier={data?.overdue_multiplier ?? 3}
            earlyMultiplier={data?.early_multiplier ?? 3}
            membersCount={data?.members_count ?? 0}
            inflationApplied={false}
            startDateJalali={data?.start_date_jalali}
        />
    ) : null

    return { open: setRow, element }
}
